import { Component, Input, Output, EventEmitter } from '@angular/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'ingo-global-error',
  templateUrl: './global-error.component.html',
  styleUrls: ['./global-error.component.scss']
})
export class GlobalErrorComponent {

  @Input() error: boolean;
  @Output() onReload: EventEmitter<void> = new EventEmitter();
  @Output() onClose: EventEmitter<void> = new EventEmitter();

  faTimes = faTimes;

  reload(): void {
    this.onReload.emit();
  }

  close(): void {
    this.onClose.emit();
  }
}
